import React, { useState, useEffect, useRef, useMemo } from "react";
import NoDataImg from "../../../Assets/img/image 12.png";
import payout from "../../../Assets/img/vector/payout.png";

import { MdOutlinePendingActions } from "react-icons/md";
import { GiMoneyStack } from "react-icons/gi";
import { MdOutlineAccountBalance } from "react-icons/md";

import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { Button } from "react-bootstrap";

const Payout = () => {
    const [paymentMethod, setPaymentMethod] = useState("");
    const [showBankFields, setShowBankFields] = useState(false);
    const [amount, setAmount] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [transactionPassword, setTransactionPassword] = useState("");
    const [paypalId, setPaypalId] = useState("");
    const [payouts, setPayouts] = useState([]);
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [payoutRequest, setPayoutRequest] = useState([]);
    const [referredUsers, setReferredUsers] = useState([]);
    const [paypal, setPaypal] = useState([]);
    const [payTypeOption, setPayTypeOption] = useState([
        { value: 1, label: "Wages" },
        { value: 2, label: "Bonus" },
        { value: 3, label: "Referral" },
    ]);
    const [referralData, setReferralData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const [isSubscribed, setIsSubscribed] = useState("no");

    useEffect(() => {
        const subscriptionStatus = sessionStorage.getItem("subscription_status");
        setIsSubscribed(subscriptionStatus === "yes");
    }, [isSubscribed]);

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    // let pkUserKey = sessionStorage.getItem("pk_user_key");
    // let reversedKey = pkUserKey.split("").reverse().join("");

    useEffect(() => {
        fetchData();
        fetchReferredUsers();
        fetchPaypalData();
        fetchReferralData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getPayout",
                fk_user_key: sessionStorage.getItem("pk_user_key"),
            });
            const output = response.data;
            setPayoutRequest(output);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchReferredUsers = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAllReferedUsers",
                user_key: sessionStorage.getItem("pk_user_key"),
            });
            const output = response.data;
            if (output.length > 0) {
                setReferredUsers(
                    output.map((option) => ({
                        value: option.pk_user_key,
                        label: option.first_name + " " + option.last_name,
                    }))
                );
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchPaypalData = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getPaypalData",
                user_key: sessionStorage.getItem("pk_user_key"),
            });
            const output = response.data;

            if (output) {
                setPaypal(output);
            }
        } catch (error) {
            toast.error("Error fetching data.", { autoClose: 3000 });
        }
    };

    const fetchReferralData = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getReferralSetting",
                user_key: sessionStorage.getItem("pk_user_key"),
            });
            const output = response.data;

            if (output) {
                setReferralData(output);
            }
        } catch (error) {
            toast.error("Error fetching data.", { autoClose: 3000 });
        }
    };

    const initialValues = {
        fk_user_key: sessionStorage.getItem("pk_user_key"),
        fk_pp_key: paypal && paypal.length > 0 ? paypal[0].pk_pp_key : "",
        referred_user_key: "",
        created_by: sessionStorage.getItem("pk_user_key"),
        visibility: 1,
        amount: "",
        description: "",
        status: "1",
        payout_type: "",
    };

    const basicSchema = Yup.object().shape({
        amount: Yup.string().required("Amount is required."),
        description: Yup.string().required("Description is required."),
        payout_type: Yup.string().required("Please select a payout request type."),
        // referred_user_key: Yup.string().required("Please select a referred user."),
        referred_user_key: Yup.string().when("payout_type", (payout_type, schema) => {
            console.log(payout_type[0]);
            return payout_type[0] === "3" ? schema.required("Please select a referred user.") : schema;
        }),
        // referred_user_key: Yup.string().when("payout_type", {
        //     is: "3", // Check if payout_type is "3"
        //     then: Yup.string().required("Please select a referred user."),
        //     otherwise: Yup.string(), // No validation for other values
        // }),
        // referred_user_key: Yup.string().when("payout_type", (payout_type, schema) => {
        //     return payout_type === "3" ? schema.required("Please select a referred user.") : schema.notRequired(); // Use .notRequired() when it's not needed
        // }),

        fk_pp_key: Yup.string().test("paypal-id-check", "Please add PayPal ID in settings.", (value) => {
            return businessId || pkPPKey;
        }),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();
            setIsSubmitting(true);

            try {
                const response = await axios.post(
                    BASE_URL + "API/apicall",
                    {
                        security_key: security_key,
                        mode: "payoutRequest",
                        ...formValues,
                    },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                const output = response.data;
                if (output === 1) {
                    resetForm();
                    setValues({
                        ...initialValues,
                        payout_type: "",
                    });
                    fetchData();
                    toast.success("Request sent successfully!", {
                        autoClose: 3000,
                    });
                } else {
                    toast.error("Oops! Something went wrong.", {
                        autoClose: 3000,
                    });
                }
            } catch (error) {
                toast.error("Something went wrong while submitting the request.", {
                    autoClose: 3000,
                });
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };

    const pendingRequest = payoutRequest.filter((payout) => payout.status === 1).reduce((sum, payout) => sum + parseFloat(payout.amount), 0);

    const totalPayout = payoutRequest.filter((payout) => payout.status === 2).reduce((sum, payout) => sum + parseFloat(payout.amount), 0);

    useEffect(() => {
        if (values.payout_type === 3 && referralData.length > 0) {
            // Set the amount and description based on referral data
            setValues({
                ...values,
                amount: referralData[0].amount,
                description: referralData[0].description,
            });
        }
    }, [values.payout_type, referralData, setValues]);

    const businessId = paypal && paypal.length > 0 ? paypal[0].business_id : "";
    const pkPPKey = paypal && paypal.length > 0 ? paypal[0].pk_pp_key : "";
    const Description = referralData && referralData.length > 0 ? referralData[0].description : "";
    const Amount = referralData && referralData.length > 0 ? referralData[0].amount : "";

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const filteredPayouts = useMemo(() => {
        handlePageChange(1);
        return payoutRequest.filter((payout) => {
            const searchLower = searchTerm.toLowerCase();

            const statusText = payout.status === 1 ? "pending" : payout.status === 2 ? "completed" : "";

            return (
                (payout.amount && `${payout.amount}`.toLowerCase().includes(searchLower)) ||
                (payout.created_on && formatDate(payout.created_on).toLowerCase().includes(searchLower)) ||
                (statusText && statusText.toLowerCase().includes(searchLower)) ||
                (payout.description && payout.description.toLowerCase().includes(searchLower))
            );
        });
    }, [payoutRequest, searchTerm]);

    useEffect(() => {
        if (values.payout_type !== 3) {
            handleChange({ target: { name: "amount", value: "" } });
            handleChange({ target: { name: "description", value: "" } });
        }
    }, [values.payout_type, handleChange]);

    const ITEMS_PER_PAGE = 10;

    const paginatedMagazines = useMemo(() => {
        const start = (currentPage - 1) * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;
        return filteredPayouts.slice(start, end);
    }, [filteredPayouts, currentPage]);

    const totalPages = Math.ceil(filteredPayouts.length / ITEMS_PER_PAGE);

    useEffect(() => {
        if (values.payout_type === 3 && referralData && referralData.length > 0) {
            // If status is inactive, reset form fields
            if (referralData[0].status !== 1) {
                // Reset the values for 'amount' and 'description'
                handleChange({ target: { name: "amount", value: "" } });
                handleChange({ target: { name: "description", value: "" } });
                handleChange({ target: { name: "referred_user_key", value: "" } });
            }
        }
    }, [referralData, values.payout_type, handleChange]);

    return (
        <section className="pb-3">
            <ToastContainer position="top-center" />
            <div className="main-content">
                <h3 className="page-title">Payout</h3>
                <div className="row g-2">
                    <div className="col-md-12 col-lg-4 px-2">
                        <div className="head-box p-3 d-flex">
                            <div className="icon-box bg-white">
                                <MdOutlinePendingActions className="f-32" />
                            </div>
                            <div className="box px-2">
                                <div className="text-box">
                                    <p>Pending Request</p>
                                    <span className="head-box-count">${pendingRequest.toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-4 px-2">
                        <div className="head-box p-3 d-flex">
                            <div className="icon-box">
                                <GiMoneyStack className="f-32" />
                            </div>
                            <div className="box px-2">
                                <div className="text-box">
                                    <p>Total Payout</p>
                                    <span className="head-box-count">${totalPayout.toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-12 col-lg-4 px-2">
              <div className="head-box p-3 d-flex">
                <div className="icon-box">
                  <MdOutlineAccountBalance className="f-32" />
                </div>
                <div className="box px-2">
                  <div className="text-box">
                    <p>Available Balance</p>
                    <span className="head-box-count">$400.00</span>
                  </div>
                </div>
              </div>
            </div> */}
                    <div className="col-12 px-2 h-100">
                        <div className="m-wrapper mt-3 p-3">
                            <div className="input-group mb-3 d-flex gap-3 align-items-center justify-content-between">
                                <div className="net-input-field">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                        aria-label="Search"
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                <div className="net-input-field">
                                    <button
                                        className="btn btn-dark border border-dark ms-2 payout-btn rounded-2"
                                        type="button"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRight"
                                        aria-controls="offcanvasRight"
                                        disabled={!isSubscribed}
                                    >
                                        <img src={payout} className="img-fluid pe-1 pb-1" alt="" />
                                        Payout Request
                                    </button>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            {/* <th className="bg-5">Transaction ID</th> */}
                                            <th className="bg-5">Description</th>
                                            <th className="bg-5">Amount</th>
                                            <th className="bg-5">Status</th>
                                            <th className="bg-5">Requested date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(paginatedMagazines) && paginatedMagazines.length > 0 ? (
                                            paginatedMagazines.map((payout) => (
                                                <tr key={payout.pk_payout_key}>
                                                    {/* <td>{payout.pk_payout_key}</td> */}
                                                    <td>{payout.description}</td>
                                                    <td>${payout.amount}</td>
                                                    <td>{payout.status === 1 ? "Pending" : "Completed"}</td>
                                                    <td>{formatDate(payout.created_on)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    <div className="d-flex flex-column align-items-center">
                                                        <img src={NoDataImg} alt="No data" className="img-fluid" />
                                                        <span>No Data available</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pagination d-flex justify-content-end mb-3 my-3">
                    <Button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="btn btn-light mx-1">
                        &lt;&lt;
                    </Button>
                    <Button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="btn btn-light mx-1">
                        &lt;
                    </Button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <Button
                            key={index + 1}
                            onClick={() => handlePageChange(index + 1)}
                            className={`mx-1 ${currentPage === index + 1 ? "btn-dark text-white" : "btn-light"}`}
                        >
                            {index + 1}
                        </Button>
                    ))}
                    <Button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="btn btn-light mx-1">
                        &gt;
                    </Button>
                    <Button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="btn btn-light mx-1">
                        &gt;&gt;
                    </Button>
                </div>
            </div>

            {/* Offcanvas Menu */}
            <form onSubmit={handleSubmit}>
                <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                    <div className="offcanvas-header">
                        <h5 id="offcanvasRightLabel" className="fw-bold">
                            Request Payout
                        </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>
                    <div className="offcanvas-body">
                        <div className="mb-3">
                            <label className="form-label">Request Type</label>
                            <Select
                                options={payTypeOption}
                                id="payout_type"
                                name="payout_type"
                                value={payTypeOption.filter((option) => values.payout_type && values.payout_type == option.value)}
                                // value={
                                //     Array.isArray(type) &&
                                //     type.find((option) => option.value && values.payout_type && option.value.toString() === values.payout_type.toString())
                                // }
                                onChange={(selectedOption) => {
                                    const event = {
                                        target: {
                                            name: "payout_type",
                                            value: selectedOption["value"],
                                        },
                                    };
                                    // console.log(event);
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    // console.log(event);

                                    handleBlur(event);
                                    setTouched({ ...touched, payout_type: true });
                                }}
                            />
                            {errors.payout_type && touched.payout_type && <p className="text-danger">{errors.payout_type}</p>}
                        </div>
                        {/* Conditionally render based on selected type */}
                        {values.payout_type && (values.payout_type === 1 || values.payout_type === 2) && (
                            <>
                                <div className="mb-3">
                                    <label htmlFor="amount" className="form-label">
                                        Request Amount <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="amount"
                                        value={values.amount}
                                        onChange={handleChange}
                                        placeholder="Enter amount"
                                    />
                                    {errors.amount && touched.amount && <p className="error-msg text-danger">{errors.amount}</p>}
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="description" className="form-label">
                                        Description <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="description"
                                        value={values.description}
                                        onChange={handleChange}
                                        placeholder="Enter Description"
                                    />
                                    {errors.description && touched.description && <p className="error-msg text-danger">{errors.description}</p>}
                                </div>
                            </>
                        )}

                        {/* Conditionally render for Referral type */}
                        {values.payout_type === 3 && (
                            <>
                                {referralData && referralData.length > 0 && referralData[0].status === 1 ? (
                                    <>
                                        <div className="mb-3">
                                            <label htmlFor="amount" className="form-label">
                                                Request Amount <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="amount"
                                                value={Amount}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                readOnly={true}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="description" className="form-label">
                                                Description <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                name="description"
                                                value={Description}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                readOnly={true}
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="mb-3">
                                            <label htmlFor="amount" className="form-label">
                                                Request Amount <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="amount"
                                                value={values.amount}
                                                onChange={handleChange}
                                                placeholder="Enter amount"
                                            />
                                            {errors.amount && touched.amount && <p className="error-msg text-danger">{errors.amount}</p>}
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="description" className="form-label">
                                                Description <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                id="description"
                                                value={values.description}
                                                onChange={handleChange}
                                                placeholder="Enter Description"
                                            />
                                            {errors.description && touched.description && <p className="error-msg text-danger">{errors.description}</p>}
                                        </div>
                                    </>
                                )}
                                {/* Referred User Select */}
                                <div className="mb-3">
                                    <label htmlFor="referredUser" className="form-label">
                                        Select Referred User <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        options={referredUsers}
                                        id="referred_user_key"
                                        name="referred_user_key"
                                        // value={referredUsers.filter((option) => values.referred_user_key.includes(option.value))}
                                        value={referredUsers.filter((option) => option.value == values.referred_user_key)}
                                        onChange={(selectedOption) => {
                                            const event = {
                                                target: {
                                                    name: "referred_user_key",
                                                    value: selectedOption["value"], // Map to an array of selected values
                                                },
                                            };
                                            handleChange(event);
                                        }}
                                        onBlur={(event) => {
                                            handleBlur(event);
                                            setTouched({ ...touched, referred_user_key: true });
                                        }}
                                    />
                                    {errors.referred_user_key && touched.referred_user_key && (
                                        <p className="error-msg text-danger">{errors.referred_user_key}</p>
                                    )}
                                </div>
                            </>
                        )}

                        <div className="mb-3">
                            <label htmlFor="fk_pp_key" className="form-label">
                                PayPal ID <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                name="fk_pp_key"
                                value={businessId}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                readOnly={true}
                            />
                            {errors.fk_pp_key && touched.fk_pp_key && <p className="error-msg text-danger">{errors.fk_pp_key}</p>}
                        </div>
                    </div>
                    <div className="btn-pay-home p-3">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="btn btn-dark rounded-3"
                            // onClick={handleSubmit}
                        >
                            Request
                        </button>
                    </div>
                </div>
            </form>
            {/* Offcanvas Menu End */}

            <style jsx>
                {`
                    .download-btn {
                        width: 92px;
                    }

                    .net-input-field input,
                    select {
                        width: 252px !important;
                        height: 42px;
                        padding: 11px;
                        border-radius: 4px;
                        outline: none;
                        transition: border-color 0.3s;
                    }
                    .w-90 {
                        width: 90%;
                    }
                    .money-box {
                        background-color: #d9d9d9 !important;
                    }
                    .money-box-count {
                        font-weight: 600;
                    }
                    .form-select {
                        height: inherit;
                        border-radius: 0px !important;
                        box-shadow: unset !important;
                    }
                `}
            </style>
        </section>
    );
};

export default Payout;
